import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {animateScroll as scroll} from 'react-scroll';

export const ModalesMisPacientes = (props) => {
	const {
		ErroresFormulario,
		setErroresFormulario,
		ModalErrores,
		setModalErrores,
		ModalCorrecto,
		setModalCorrecto,
		setViewFormPaciente,
		idPaciente,
		ModalBorrarPaciente,
		setModalBorrarPaciente,
		Paciente,
		deletePaciente,
		ModalPacienteDelteOk,
		setModalPacienteDelteOk,
		ModalPacienteDelteNoOk,
		setModalPacienteDelteNoOk,
	} = props;
	return (
		<>
			<Modal
				centered={true}
				isOpen={ModalErrores}
			>
				<ModalHeader>
					<div className='titulo-modal'>Datos del paciente erróneos</div>
				</ModalHeader>
				<ModalBody>
					<div>
						{' '}
						{ErroresFormulario.map((error) => (
							<div className='descripcion-servicio descripcion-modal'>
								{' '}
								- {error}{' '}
							</div>
						))}{' '}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setModalErrores(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalPacienteDelteOk}
			>
				<ModalHeader>
					<div className='titulo-modal'>Usuario eliminado</div>
				</ModalHeader>
				<ModalBody>
					<div> Enorabuena su usuario ha sido elimiando correctamente </div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setModalPacienteDelteOk(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalPacienteDelteNoOk}
			>
				<ModalHeader>
					<div className='titulo-modal'>Ups... Ha habido un problema</div>
				</ModalHeader>
				<ModalBody>
					<div>
						No ha sido posible eliminar este usuario, por favor intentelo
						de nuevo mas tarde.
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setModalPacienteDelteNoOk(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalCorrecto}
			>
				<ModalHeader>
					<div className='titulo-modal'>Enhorabuena</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						{idPaciente == undefined
							? '¡Paciente registrado correctamente!'
							: '¡Paciente actualizado correctamente!'}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => {
								setModalCorrecto(false);
								setViewFormPaciente(false);
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalBorrarPaciente}
			>
				<ModalHeader>
					<div className='titulo-modal'>Eliminar paciente</div>
				</ModalHeader>
				<ModalBody>
					{Paciente !== undefined && (
						<div className='descripcion-servicio descripcion-modal'>
							<div>
								<p>¿Estas segura/o de que deseas eliminar este paciente?</p>
							</div>
							<div>
								<p>
									<b>Nombre: </b>
									{Paciente.nombrePaciente}
								</p>
							</div>
							<div>
								<p>
									<b>DNI: </b>
									{Paciente.dniPaciente}
								</p>
							</div>
							<div>
								<p>
									Todos los servicios asociados con este paciente seran
									eliminados.
								</p>
							</div>
						</div>
					)}
				</ModalBody>
				<ModalFooter>
					<div className='buttons-modal__EliminarEncuesta'>
						<div
							className='button borrarCuenta'
							onClick={() => {
								deletePaciente();
								scroll.scrollToTop();
								setModalBorrarPaciente(false);
							}}
						>
							<b>Eliminar</b>
						</div>

						<div
							className='button'
							onClick={() => {
								setModalBorrarPaciente(false);
							}}
						>
							<b>Cancelar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
